// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attribute-filter {
  width: 100%;
}

.attribute-filter-section + .attribute-filter-section {
  margin-top: 20px;
}

.attribute-filter-section-title {
  margin: 0 0 8px;
  padding: 0 12px;
  font-size: 1rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.72);
}

.attribute-filter-field {
  min-width: 180px;
}

.attribute-multi-enum-checkbox-filter {
  width: 100%;
  padding-top: 4px;
}

.multi-enum-filter-label {
  display: block;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 8px;
}

.multi-enum-filter-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
}

.attribute-range-filter {
  width: 100%;
  padding-top: 4px;
}

.range-filter-label {
  display: block;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 8px;
}

.attribute-filter-overflow {
  display: flex;
  align-items: flex-end;
}

.attribute-filter-overflow-btn {
  width: 100%;
  min-height: 56px;
  line-height: 1.2;
  white-space: normal;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/attribute-filter/attribute-filter.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AACF","sourcesContent":[".attribute-filter {\n  width: 100%;\n}\n\n.attribute-filter-section + .attribute-filter-section {\n  margin-top: 20px;\n}\n\n.attribute-filter-section-title {\n  margin: 0 0 8px;\n  padding: 0 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.72);\n}\n\n.attribute-filter-field {\n  min-width: 180px;\n}\n\n.attribute-multi-enum-checkbox-filter {\n  width: 100%;\n  padding-top: 4px;\n}\n\n.multi-enum-filter-label {\n  display: block;\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.7);\n  margin-bottom: 8px;\n}\n\n.multi-enum-filter-checkboxes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 16px;\n}\n\n.attribute-range-filter {\n  width: 100%;\n  padding-top: 4px;\n}\n\n.range-filter-label {\n  display: block;\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.7);\n  margin-bottom: 8px;\n}\n\n.attribute-filter-overflow {\n  display: flex;\n  align-items: flex-end;\n}\n\n.attribute-filter-overflow-btn {\n  width: 100%;\n  min-height: 56px;\n  line-height: 1.2;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
